import template from './advertInlinePage.html';
import controller from './advertInlinePage.controller';
import './advertInlinePage.scss';

let advertInlinePageComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default advertInlinePageComponent;
